<div class="ai-chat-popout allo-panel">
  @if (showChat()) {
    <header class="ai-chat-popout__header allo-header">
      <div class="header-left ai-chat-popout__brand">
        <div class="allo-logo">
          <div class="allo-icon ai-chat-popout__logo" aria-hidden="true">
            <img
              src="assets/img/allo-ai-logo.svg"
              alt=""
              width="24"
              height="24" />
          </div>
          <span class="allo-title ai-chat-popout__name">
            {{ 'GNR_AI_ALLO' | translate }}
          </span>
        </div>
      </div>
      <div class="header-right ai-chat-popout__actions">
        <button
          class="header-btn new-chat ai-chat-popout__new-btn"
          [class.header-btn--active]="selectedChatId() === null"
          type="button"
          (click)="startNewChat()"
          [attr.aria-label]="'GNR_NEW_CHAT' | translate"
          [matTooltip]="'GNR_NEW_CHAT' | translate"
          matTooltipPosition="below">
          <mat-icon>add</mat-icon>
          <span class="header-btn__label">{{
            'GNR_NEW_CHAT' | translate
          }}</span>
        </button>
        <button
          class="header-btn ai-chat-popout__history-btn"
          type="button"
          (click)="toggleHistory()"
          [class.header-btn--active]="showHistory()"
          [attr.aria-label]="'GNR_HISTORY' | translate"
          [matTooltip]="'GNR_HISTORY' | translate"
          matTooltipPosition="below">
          <mat-icon>history</mat-icon>
          <span class="header-btn__label">{{ 'GNR_HISTORY' | translate }}</span>
        </button>
        <button
          class="header-btn ai-chat-popout__settings-btn"
          type="button"
          data-testid="allo-settings-toggle"
          (click)="toggleSettings()"
          [class.header-btn--active]="showSettings()"
          [attr.aria-label]="
            (unseenMemoryChange() ? 'GNR_ALLO_MEMORY_UPDATED' : 'GNR_SETTINGS')
              | translate
          "
          [attr.aria-expanded]="showSettings()"
          [matTooltip]="
            (unseenMemoryChange() ? 'GNR_ALLO_MEMORY_UPDATED' : 'GNR_SETTINGS')
              | translate
          "
          matTooltipPosition="below">
          <mat-icon>settings</mat-icon>
          @if (unseenMemoryChange()) {
            <span
              class="header-btn__dot"
              data-testid="allo-settings-unseen-dot"
              aria-hidden="true"></span>
          }
        </button>
      </div>
    </header>

    @if (showHistory()) {
      <qt-ai-chat-history
        [selectedChatId]="selectedChatId()"
        (chatSelected)="selectChat($event)"
        (chatDeleted)="onChatDeleted($event)" />
    }

    @if (showSettings()) {
      <qt-ai-chat-settings />
    }

    <div class="ai-chat-popout__body chat-body">
      @for (session of [chatSessionKey()]; track session) {
        <qt-ai-chat
          [windowId]="session"
          [chatId]="selectedChatId()"
          [lazySubscribe]="lazyChatSubscribe()"></qt-ai-chat>
      }
    </div>
  } @else {
    <div class="ai-chat-popout__empty">
      {{ 'GNR_AI_CHAT' | translate }}
    </div>
  }
</div>
